import React, { useState, useEffect } from 'react';
import './live-clock.css';

export function LiveClock(): React.ReactElement {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const dateFmt = time.toLocaleString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  const timeFmt = time.toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const tzAbbr = time.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ').pop() ?? '';

  return (
    <div className="mc-clock">
      <span className="mc-clock__time">{timeFmt}</span>
      <span className="mc-clock__date">
        {dateFmt} {tzAbbr}
      </span>
    </div>
  );
}
